/*
 * @Author: Teemo Ding
 * @Date: 2021-07-05 16:23:19
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-05 16:59:06
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/hooks/productIdHooks.tsx
 */
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useHistory } from 'react-router';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const productIdHooks = (getUuid) => {
  const _h = useHistory();

  const salesChannelProductUuidSlice: any = useSelector(getUuid());
  const _params: {
    salesChannelProductUuid: string;
    saleChannelUuid: string;
  } = useParams();
  const { salesChannelProductUuid, saleChannelUuid } = _params;
  useAfterDidMountEffect(() => {
    if (salesChannelProductUuidSlice !== salesChannelProductUuid) {
      _h.replace(
        `/salesChannel/products/content/${saleChannelUuid}/${salesChannelProductUuidSlice}`,
      );
    }
  }, [salesChannelProductUuidSlice]);
};
export { productIdHooks };
